// components/MenuItems.jsx
import { Menu } from "antd";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routesArray } from "../../constants/Routes";

const MenuItems = () => {
  const location = useLocation();
  const { t } = useTranslation();

  const isSubPath =
    location.pathname === `/cloud/${location.pathname.split("/").pop()}`;
  const currentPath = isSubPath ? "/cloud" : location.pathname;

  const menuItems = routesArray?.map((item) => ({
    key: item.path,
    label: (
      <Link className="menu-items" to={item.path}>
        <span style={{ marginTop: 7 }}>{item.icon}</span>{" "}
        {t(`menu.${item.name}`)} {/* i18n translation */}
      </Link>
    ),
  }));

  return (
    <Menu mode="inline" defaultSelectedKeys={[currentPath]} items={menuItems} />
  );
};

export default MenuItems;
